
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Atinge „Deschide în browser…”`,
's182ab2d6c997515f': `Adaugă-l pe Ecranul Principal pentru o experiență extinsă și acces facil.`,
's224cbcec014ef6b5': `Apasă Partajare în bara de navigare`,
's233af3b7eb5e0364': `Adaugă la pagina principală`,
's37a9e8aec5713460': `Mai mult`,
's4c3161035f3a1413': `Apasă Meniu`,
's4e1e10a6ca408245': `Atinge „Adaugă pe ecranul principal”`,
's6196153c4b0c1ea0': `Instalați`,
's633502f7cff4f847': `Deschide meniul browserului tău`,
's681e399d63311fba': `Afișează galeria`,
's6d14a4f70ba4e3cf': `Apasă Meniu dacă nu există pictograma Partajare`,
's922329d6f6213590': `Adaugă în Dock`,
's9c63a79ffcc2a3a3': `Apasă pe „Adaugă pe ecranul principal”`,
'sa2d71bfd9525168d': `Apasă pe „Adaugă în Dock”`,
'sa5ef80b4bb9b39f8': `Mai puțin`,
'sb527eca1c1d7e7be': `Deschide meniul browserului din aplicație`,
'sba52286c21552a4e': `Instalează-l pe dispozitivul tău pentru o experiență completă și acces facil.`,
'sc16e00a7a8b2fde2': `Înapoi`,
'scdaf4bbff76674c8': `Adaugă pe Ecranul Principal`,
'sd18a5b85f599ff3c': `Deschide linkul copiat în Safari`,
'se72fc3a84f9b51c3': `Atinge pentru a copia linkul`,
'se740f75b95a51807': `Adaugă-l în Dock pentru o experiență extinsă și acces facil.`,
'sfa6c42cdf48d93d2': `Dar acest browser nu acceptă această funcție. Pentru a continua, deschide linkul într-un browser extern.`,
'sfb78526365796a41': `Apasă „Vezi mai multe” în meniul Partajare`,
'sfea652f6580ff086': `Acest site are funcționalități de aplicație.`,
    };
  